import { EXPIRY_SKEW_MS, EXPORT_STATUS, STALE_RECOVERY_WINDOW_MS, STATUS_RANK } from './constants';

export const isLinkUsable = (job) =>
  !!job?.downloadUrl && (!job?.expiresAt || Date.now() < job.expiresAt - EXPIRY_SKEW_MS);

// An export past the PDF row cap is delivered as several files. Older jobs (and every
// single-file export) carry only the top-level link, so synthesize a one-entry list.
export const exportFiles = (job) => {
  if (Array.isArray(job?.files) && job.files.length) return job.files;
  if (!job?.downloadUrl && !job?.fileName) return [];
  return [
    {
      part: 1,
      fileName: job.fileName,
      downloadUrl: job.downloadUrl,
      expiresAt: job.expiresAt
    }
  ];
};

export const isTerminalStatus = (status) =>
  status === EXPORT_STATUS.COMPLETED || status === EXPORT_STATUS.FAILED;

export const isExportDone = (job) => isTerminalStatus(job?.status);

export const isStaleFailed = (job) =>
  job?.status === EXPORT_STATUS.FAILED &&
  !!job?.stale &&
  (!job.staleSince || Date.now() - job.staleSince < STALE_RECOVERY_WINDOW_MS);

export const rankStatus = (status) => STATUS_RANK[status] ?? -1;

// Forward-only status transition. Never regress a status the socket already advanced,
// and preserve the first terminal status — except that `completed` always wins, because
// list_jobs reports a long-running job as failed on a timeout it later recovers from,
// and `completed` is the only status carrying a downloadable artifact.
export const advanceStatus = (prevStatus, nextStatus) => {
  if (nextStatus === EXPORT_STATUS.COMPLETED) return nextStatus;
  if (rankStatus(nextStatus) < rankStatus(prevStatus)) return prevStatus;
  if (isTerminalStatus(prevStatus) && nextStatus !== prevStatus) return prevStatus;
  return nextStatus;
};

export const exportProgress = (job) => {
  if (isTerminalStatus(job?.status)) return 100;
  if (job?.status === EXPORT_STATUS.RUNNING) return 66;
  return 10; // queued
};

export const exportStatusLabel = (job) => {
  if (job?.status === EXPORT_STATUS.FAILED) return 'Failed';
  if (job?.status === EXPORT_STATUS.COMPLETED) return 'Ready to download';
  if (job?.status === EXPORT_STATUS.RUNNING) return 'Generating…';
  return 'Preparing…';
};

const TYPE_LABELS = {
  invoice: 'Invoice PDF',
  report: 'Report PDF'
};

export const exportTypeLabel = (type) => TYPE_LABELS[type] || 'Export';
